<template>
  <div class="dealer-banner" v-if="dealerViewingUser && user.isDealerUser">
    <v-container class="pr-12">
      <v-row>
        <v-col cols="12" sm="5" offset-sm="4" class="pl-12 pb-1 pt-2">
          {{ $t('dealer.loggedIntoCustomer') }}:
          <div class="font-weight-bold" style="display: inline">
            {{ dealerViewingLocation }}
          </div>
        </v-col>
        <v-col cols="12" sm="3" class="py-1">
          <v-btn
            light
            class="font-weight-bold"
            style="float: right"
            @click="backToDealer"
            data-testid="dealer-banner-back-to-dealer"
          >
            {{ $t('dealer.backToDealerPortal') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapActions, mapState } from 'vuex'

export default defineComponent({
  name: 'DealerBanner',
  computed: {
    ...mapState('Security', [
      'dealerViewingUser',
      'dealerViewingLocation',
      'dealerViewingUserFromDashboard',
      'dealerCustomerId',
      'dealerLocationId',
      'user',
    ]),
  },
  methods: {
    ...mapActions('Security', ['callSetDealerViewingUser']),
    backToDealer() {
      let payload = {
        dealerViewingUser: false,
        dealerCustomerId: 0,
        dealerLocationId: 0,
        dealerViewingLocation: '',
        dealerViewingUserFromDashboard: false,
      }
      if (this.dealerViewingUserFromDashboard) {
        this.$router.push({ name: 'Dashboard' })
      } else if (this.dealerLocationId > 0) {
        this.$router.push({
          name: 'CustomerLocation',
          params: {
            locationId: this.dealerLocationId,
            id: this.dealerCustomerId,
          },
        })
      } else if (this.dealerCustomerId == 0) {
        this.$router.push('/dashboard')
      } else {
        this.$router.push('/customers/' + parseInt(this.dealerCustomerId))
      }
      this.callSetDealerViewingUser(payload)
    },
  },
})
</script>

<style lang="scss">
.dealer-banner {
  background-color: $color-secondary;
}
</style>
